module.exports.css = require ("style!css!resolve-url!sass?sourceMap!./lib/bootstrap.styles.loader.js?{\"bootstrapVersion\":3,\"extractStyles\":false,\"styleLoaders\":[\"style\",\"css\",\"sass\"],\"styles\":[\"mixins\",\"modals\",\"close\",\"component-animations\",\"utilities\"],\"scripts\":false,\"configFilePath\":\"/Users/vml183/MyWorkspace/vue2-bootstrap-modal/.bootstraprc\",\"bootstrapPath\":\"/Users/vml183/MyWorkspace/vue2-bootstrap-modal/node_modules/bootstrap-sass\",\"bootstrapRelPath\":\"../bootstrap-sass\"}!./no-op.js");



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/lib/bootstrap.loader.js!./~/bootstrap-loader/no-op.js
// module id = 4
// module chunks = 0